import { SubscriptionDurationList, SubscriptionPlan, SubscriptionPlanGrantRequest, SubscriptionTierList, UpsertSubscriptionPlan } from '@/models/subscription-plan.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedSubscriptionPlans = async (input: PaginationFilterRequest): Promise<PagedResponseModel<SubscriptionPlan>> => {
  return await getReq(createUrl("a/Subscription/Plan/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getSubscriptionPlansLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedSubscriptionPlans(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${SubscriptionTierList.find(t => t.value === itm.tier)?.label ?? "Unknown Tier"} - ${SubscriptionDurationList.find(d => d.value === itm.duration)?.label ?? "Unknown Duration"}`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getSubscriptionPlan = async (id: number): Promise<BaseResponseModel<SubscriptionPlan>> => {
  return await getReq(createUrl(`a/Subscription/Plan/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertSubscriptionPlan = async (input: UpsertSubscriptionPlan): Promise<BaseResponseModel<SubscriptionPlan>> => {
  return await postReq(createUrl("a/Subscription/Plan/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const grantSubscriptionPlanToUser = async (input: SubscriptionPlanGrantRequest): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/Subscription/Plan/GrantToUser"),
    input
  ).then((res: any) => res.data);
};